export const STORE_OVERVIEW_PREFERENCES = {
  REIMBURSEMENT: 'reimbursement',
  SHIPPING: 'shipping',
  VAT: 'vat',
  PPC: 'ppc',
  DSP: 'dsp',
};
